import { render, staticRenderFns } from "./billAddressDialog.vue?vue&type=template&id=1b3a0cbc&"
import script from "./billAddressDialog.vue?vue&type=script&lang=js&"
export * from "./billAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3a0cbc')) {
      api.createRecord('1b3a0cbc', component.options)
    } else {
      api.reload('1b3a0cbc', component.options)
    }
    module.hot.accept("./billAddressDialog.vue?vue&type=template&id=1b3a0cbc&", function () {
      api.rerender('1b3a0cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Order/billAddressDialog.vue"
export default component.exports